import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function ContactFormModal(props) {
  const { open, handleClose, result } = props;

  return (
    <div>
      {result === "success" ? (
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="xs"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Mensagem enviada com sucesso!"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Entraremos em contato em breve.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      ) : result === null ? (
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="xs"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Enviando mensagem..."}
          </DialogTitle>
          <DialogContent style={{ margin: "auto auto 20px auto" }}>
            <CircularProgress />
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="xs"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Erro ao enviar"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Cheque as informações inseridas e tente mais tarde.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
